import React, { Component } from 'react';
import { Button, Result } from 'antd';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  componentDidCatch() {
    this.setState({
      error: true,
    });
    setTimeout(() => {
      document.title = 'Ошибка';
    }, 0);
  }

  resetError = () => {
    this.setState({
      error: false,
    });
  };

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <Result
          status="500"
          title="Упс похоже что-то пошло не так..."
          subTitle="Обратитесь к вашим разработчикам для решения проблемы, а пока можете вернуться назад."
          extra={
            <Button onClick={this.resetError} type="primary">
              Назад
            </Button>
          }
        />
      );
    }

    return children;
  }
}

export { ErrorBoundary };
